import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { CodeSwitcher } from './components/code-switcher';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <div id="code-examples">
      <h2>{`Code Example`}</h2>
      <p>{`Below are code samples for using the `}<a href="/docs/api/endpoint#search">{`Search Endpoint`}</a>{` in Python, JavaScript, Ruby, PHP and the command line on connecting to the API to make a search query for "Ryan Gosling."`}</p>
      <CodeSwitcher apiName="search" mdxType="CodeSwitcher" />
      <p>{`Below are code samples for using the `}<a href="/docs/api/endpoint#upload">{`Upload Endpoint`}</a></p>
      <CodeSwitcher apiName="upload" mdxType="CodeSwitcher" />
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      